import { cn } from "@msuite/ui/utils";
import type { SubstitutionPlanSummaryItemSchema } from "@msuite/utils/schemas";
import { guardString } from "@msuite/utils/strings";
import { getFullName } from "@msuite/utils/users";
import { gridClasses } from "@/components/substitutions/substitution-plan-summary/shared";

/** Props Interface */
interface SubstitutionPlanSummaryItemProps {
	item: SubstitutionPlanSummaryItemSchema;
}

// const keys: Array<keyof SubstitutionPlanSummaryItemSchema> = ["substitutions", "contacts"] as const;

export function SubstitutionPlanSummaryItem({ item }: SubstitutionPlanSummaryItemProps) {
	const gc = gridClasses();
	const listKeys: Array<keyof Pick<typeof item, "contacts" | "substitutions">> = [
		"substitutions",
		"contacts",
	] as const;

	return (
		<div
			className={cn(
				gc,
				"*:v-stack *:gap-0 p-0 *:p-3",
				"*:not-last:border-r-[0.5px] *:border-color",
			)}
		>
			<div>
				<p className="font-medium">{guardString(item.projectName)}</p>
				<p className="tabular-nums text-sm label">{guardString(item.projectNumber)}</p>
			</div>
			{listKeys.map((key) => (
				<div key={key}>
					{!item[key].length && <p>{guardString(null)}</p>}
					{item[key].map((item, index) => (
						<p key={item.id}>
							{index + 1}. {getFullName(item)}
						</p>
					))}
				</div>
			))}
			<div>
				<p className="label">{guardString(item.quickNote)}</p>
			</div>
		</div>
	);
}
